import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const HouseKeepingBundleReceiptEntry = () => {
  return (
    <SectionBundleReceiptEntry
      sectionName="House Keeping"
      sectionDisplayName="House Keeping Section"
      backRoute="/sections/house-keeping"
    />
  );
};

export default HouseKeepingBundleReceiptEntry;
